<template>
  <div>
    <base-nav
      container-classes="container-fluid"
      class="navbar-top navbar-expand mb-2 mt-1"
      :class="{ '': type === 'default' }"
    >
      <!-- Search form -->
      <div class="ml--3 main-search">
        <customer-search></customer-search>
      </div>
      <!-- Navbar links -->
      <b-navbar-nav class="align-items-center ml-md-auto">
        <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
        <li class="nav-item d-xl-none">
          <!-- Sidenav toggler -->
          <div
            class="pr-3 sidenav-toggler"
            :class="{
              active: $sidebar.showSidebar,
              'sidenav-toggler-dark': type === 'default',
              'sidenav-toggler-light': type === 'light',
            }"
            @click="toggleSidebar"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
        <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
        <li class="nav-item d-sm-none">
          <a
            class="nav-link"
            href="#"
            data-action="search-show"
            data-target="#navbar-search-main"
          >
            <i class="ni ni-zoom-split-in"></i>
          </a>
        </li>
      </b-navbar-nav>

      <b-navbar-nav class="align-items-center ml-auto ml-md-0">
        <b-dropdown
          id="dropdown-1"
          variant="link"
          no-caret
          @hidden="viewedCompanyNotification"
          @show="getLatestNotifications"
          size="lg"
          toggle-class="text-decoration-none"
          class="m-md-2"
          menu-class="dropdown-menu-xl dropdown-menu-right py-0 overflow-hidden"
        >
          <template #button-content>
            <b-badge
              variant="danger"
              v-if="
                companyNotifications.filter(
                  (e) => e.dateTime > lastViewedCompanyNotification
                ).length > 0
              "
            >
              <i class="ni ni-bell-55 menu-bell"></i>
              {{
                companyNotifications.filter(
                  (e) => e.dateTime > lastViewedCompanyNotification
                ).length
              }}</b-badge
            >
            <i v-else class="ni ni-bell-55 menu-bell"></i>
          </template>

          <b-dropdown-group id="dropdown-group-1" header="Recent">
            <component
              :title="'before'"
              v-for="companyNotification in companyNotifications.filter(
                (e) => e.dateTime > lastViewedCompanyNotification
              )"
              v-bind:key="
                companyNotification.type + ':' + companyNotification.id
              "
              v-bind:is="companyNotification.type"
              :companyNotification="companyNotification"
            ></component>
          </b-dropdown-group>

          <b-dropdown-group id="dropdown-group-1" header="Previous">
            <component
              :title="'before'"
              v-for="companyNotification in companyNotifications.filter(
                (e) => e.dateTime < lastViewedCompanyNotification
              )"
              v-bind:key="
                companyNotification.type + ':' + companyNotification.id
              "
              v-bind:is="companyNotification.type"
              :companyNotification="companyNotification"
            ></component>
          </b-dropdown-group>
        </b-dropdown>

        <base-dropdown
          menu-on-right
          class="nav-item"
          tag="li"
          title-tag="a"
          title-classes="nav-link pr-0"
        >
          <a
            href="#"
            class="nav-link pr-0"
            @click.prevent
            slot="title-container"
          >
            <b-media no-body class="align-items-center">
              <b-avatar :src="avatar" :size="40" />

              <b-media-body class="ml-2 d-none d-lg-block">
                <span class="menu-name">{{ name }}</span>
                <span class="menu-company">{{ companyName }}</span>
              </b-media-body>
            </b-media>
          </a>

          <template>
            <b-dropdown-item
              href="/#/manageMembership"
              v-if="hasRole('MANAGEMEMBERSHIPS')"
            >
              <i class="fa-solid fa-family-pants"></i>
              <span>Membership Administration</span>
            </b-dropdown-item>

            <b-dropdown-item href="/#/manageProcedures" v-if="hasRole('BETA')">
              <i class="fa-solid fa-user-circle"></i>
              <span>Manage Procedures</span>
            </b-dropdown-item>

            <b-dropdown-item href="/#/manageSchedule" v-if="hasRole('BETA')">
              <i class="fa-solid fa-user-circle"></i>
              <span>Manage Schedule</span>
            </b-dropdown-item>

            <div
              v-if="hasRole('MANAGEMEMBERSHIPS')"
              class="dropdown-divider"
            ></div>

            <b-dropdown-item
              v-if="isAdministrator != 'false'"
              :href="'/#/admin'"
            >
              <i class="fa-solid fa-chart-mixed"></i>
              <span>Admin Dashboard</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="isAdministrator != 'false'"
              :href="'/#/admin/company/' + this.companyId"
            >
              <i class="fa-solid fa-id-badge"></i>
              <span>{{ companyName }} Admin</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="isAdministrator != 'false'"
              :href="'/#/admin/companies'"
            >
              <i class="fa-solid fa-tooth"></i>
              <span>Companies</span>
            </b-dropdown-item>

            <div
              class="dropdown-divider"
              v-if="isAdministrator != 'false'"
            ></div>

            <b-dropdown-item
              href="/#/companyProfile"
              v-if="hasRole('MANAGESETTINGS')"
            >
              <i class="fa-solid fa-cog"></i>
              <span>Settings</span>
            </b-dropdown-item>

            <b-dropdown-item
              target="_blank"
              :href="
                'https://' +
                  systemContextService.getSystem().supportUrl +
                  '?practice=' +
                  companyName +
                  '&contact_name=' +
                  name +
                  '&email=' +
                  email
              "
            >
              <i class="fa-solid fa-circle-question"></i>
              <span>Support</span>
            </b-dropdown-item>

            <b-dropdown-item href="/#/Login">
              <i class="fa-solid fa-sign-out-alt"></i>
              <span>Logout</span>
            </b-dropdown-item>

            <div class="dropdown-divider"></div>

            <div class="dropdown-footer pl-3 pr-3 pt-0 pb-0">
              <h6 class="mb-0 text-muted">Version {{ releaseVersion }}</h6>
            </div>
          </template>
        </base-dropdown>
      </b-navbar-nav>
    </base-nav>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";
import CMBPastDueCompanyNotification from "@/views/Layout/CompanyNotifications/CMBPastDueCompanyNotification.vue";
import PaymentPlanCompanyNotification from "@/views/Layout/CompanyNotifications/PaymentPlanCompanyNotification.vue";
import CustomerSearch from "@/views/Components/CustomerSearch";
export default {
  components: {
    CMBPastDueCompanyNotification,
    PaymentPlanCompanyNotification,
    CollapseTransition,
    BaseNav,
    Modal,
    CustomerSearch,
  },
  inject: ["hasRole", "systemContextService"],
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },

  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      avatar: null,
      searchTerm: "",
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
      currentPatient: null,
      isSearch: false,
      searchTermClass: "",
      recentSearches: [],
      searchResults: [],
      searchPanel: null,
      selectedIndex: -1,
      lastSearch: null,
      name: null,
      email: null,
      version: null,
      companyName: null,
      isAdministrator: null,
      companyNotifications: [],
      lastViewedCompanyNotification: null,
      intervalId: null,
      companyId: null,
      releaseVersion: null,
    };
  },
  async created() {
    var self = this;
    self.name = self.$localStorageService.getItem("name");
    self.email = self.$localStorageService.getItem("email");
    self.avatar = self.$localStorageService.getItem("avatar");
    self.companyName = self.$localStorageService.getItem("companyName");
    self.isAdministrator = self.$localStorageService.getItem("isAdmin");
    self.releaseVersion = self.$localStorageService.getItem("releaseVersion");
    self.companyId = self.$localStorageService.getItem("companyId");
    self.version = self.$localStorageService.getItem("version");
    self.lastViewedCompanyNotification = self.$localStorageService.getItem(
      "lastViewedCompanyNotification"
    );
    this.startIntervalForCompanyNotifications();
    await this.getLatestNotifications();
  },
  beforeDestroy() {
    this.clearCompanyNotifications();
  },
  methods: {
    startIntervalForCompanyNotifications: function() {
      const self = this;
      self.intervalId = setInterval(async function() {
        await self.getLatestNotifications();
      }, 60000);
    },
    clearCompanyNotifications: function() {
      const self = this;
      clearInterval(self.intervalId);
    },
    async viewedCompanyNotification() {
      var r = await this.$client.post("/api/user/viewedCompanyNotification", {
        noProgress: true,
      });
      this.lastViewedCompanyNotification = r.data.value.dateTime;
      this.$localStorageService.setItem(
        "lastViewedCompanyNotification",
        r.data.value.dateTime
      );
    },
    async getLatestNotifications() {
      let r = await this.$client.get(
        "/api/companyNotification/getLatestNotifications",
        { noProgress: true }
      );
      if (r.data.isSuccess) this.companyNotifications = r.data.value;
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>
<style></style>
